import { MenuItemProps } from '@wix/thunderbolt-components-native';

export const getIsCurrentPage = (
  link: MenuItemProps['link'],
  currentPagePath: string,
) => {
  if (!link) {
    return false;
  }
  const isAnchorLink = link.anchorDataId || link.anchorCompId;
  return !isAnchorLink && link.href === currentPagePath;
};
